module.exports = __webpack_public_path__ + "img/Travel_two.2c9be886.png";